<template>
  <div class="memberships-page">
    <!-- SearchBar -->
    <div class="search-section">
      <div class="search-container">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-input 
              placeholder="Search User ID" 
              v-model="search.user_id" 
              @clear="handleSearch()"
              @keyup.enter.native="handleSearch()"
              clearable
              size="medium">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
          </el-col>
          <el-col :span="5">
            <el-input 
              placeholder="Search Membership No" 
              v-model="search.membership_no" 
              @clear="handleSearch()"
              @keyup.enter.native="handleSearch()"
              clearable
              size="medium">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="search.vip_type_id" placeholder="VIP Type" @change="handleSearch()" clearable filterable size="medium">
              <el-option
                v-for="type in vipTypes"
                :key="type.id"
                :label="type.name_zh"
                :value="type.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="search.is_active" placeholder="Status" @change="handleSearch()" clearable size="medium">
              <el-option label="失效" :value="0" />
              <el-option label="生效" :value="1" />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-date-picker
              v-model="search.start_date"
              type="datetime"
              style="width: 100%;"
              placeholder="开始日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleSearch"
            />
          </el-col>
          <el-col :span="5">
            <el-date-picker
              v-model="search.end_date"
              type="datetime"
              style="width: 100%;"
              placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleSearch"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <el-table
        :data="list"
        border
        stripe
        :header-cell-class-name="'headerBg'"
        class="custom-table"
        style="width: 100%"
      >
        <el-table-column type="index" label="#" width="40" align="center" />
        <el-table-column prop="membership_no" label="会员号" width="120" align="center" />
        <el-table-column prop="user_id" label="User ID" width="120" align="center" />
        <el-table-column prop="vip_type" label="类型" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.vip_type.name_zh || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="start_date" label="开始日期" width="160" align="center" />
        <el-table-column prop="end_date" label="结束日期" width="160" align="center" />
        <el-table-column prop="amount" label="金额" width="80" align="center">
          <template slot-scope="scope">
            ¥ {{ Number(scope.row.amount || 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="is_active" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_active ? 'success' : 'info'">
              {{ scope.row.is_active ? '生效' : '失效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" min-width="100" show-overflow-tooltip align="center" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="small" @click="openEdit(scope.row)">
              <i class="el-icon-edit" /> 编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          :layout="'total, sizes, prev, pager, next, jumper'"
          :total="total"
        />
      </div>
    </div>

    <!-- Add / Edit Dialog -->
    <el-dialog
      :title="'编辑会员记录'"
      :visible.sync="dialogVisible"
      :width="'30%'"
      class="custom-dialog"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" size="small" class="edit-form">
        <el-form-item label="会员类型">
          <el-select
            v-model="current.vip_type_id"
            placeholder="请选择会员类型"
            filterable
            style="width: 100%">
            <el-option
              v-for="type in vipTypes"
              :key="type.id"
              :label="type.name_zh"
              :value="type.id">
              <span>{{ type.name_zh }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px" v-if="type.amount !== null && type.amount !== undefined">
                ¥{{ Number(type.amount).toFixed(2) }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="current.start_date"
            type="datetime"
            placeholder="请选择开始日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="current.end_date"
            type="datetime"
            placeholder="请选择结束日期（可为空）"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="会费金额">
          <el-input-number
            v-model="current.amount"
            :min="0"
            :step="0.1"
            :precision="2"
            :controls="false"
            placeholder="请输入金额"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="current.notes"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil'

export default {
  name: 'Memberships',
  data() {
    return {
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      vipTypes: [],
      search: {
        user_id: '',
        membership_no: '',
        vip_type_id: '',
        is_active: null,
        start_date: '',
        end_date: ''
      },
      dialogVisible: false,
      current: {
        id: null,
        user_id: '',
        vip_type_id: '',
        start_date: '',
        end_date: '',
        amount: 0,
        notes: ''
      }
    }
  },
  created() {
    const qUserId = this.$route.query.user_id
    if (qUserId) {
      this.search.user_id = qUserId
    }
    this.getVipTypes()
    this.getList()
  },
  methods: {
    getVipTypes() {
      this.request
        .get('/namzar/admin/vipType')
        .then(res => {
          const data = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : []
          this.vipTypes = data.map(item => ({
            id: item.id,
            name_zh: item.name_zh,
            name_ug: item.name_ug,
            amount: item.amount
          }))
        })
        .catch(res => {
          this.$message.error(res?.message || '获取会员类型失败')
        })
    },
    handleSearch() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.search = {
        user_id: '',
        membership_no: '',
        vip_type_id: '',
        is_active: null,
        start_date: '',
        end_date: ''
      }
      this.pageNum = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.getList()
    },
    buildQueryParams() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.search.user_id) params.user_id = this.search.user_id
      if (this.search.membership_no) params.membership_no = this.search.membership_no
      if (this.search.vip_type_id) params.vip_type_id = this.search.vip_type_id
      if (this.search.is_active !== null && this.search.is_active !== undefined) {
        params.is_active = this.search.is_active
      }
      if (this.search.start_date) params.start_date = this.search.start_date
      if (this.search.end_date) params.end_date = this.search.end_date
      return params
    },
    getList() {
      this.request
        .get('/namzar/admin/memberships', { params: this.buildQueryParams() })
        .then(res => {
          const data = Array.isArray(res?.data) ? res.data : Array.isArray(res?.data?.list) ? res.data.list : Array.isArray(res) ? res : []
          this.total = res.total || res?.data?.total || data.length
          this.list = data.map(item => ({
            id: item.id,
            user_id: item.user_id,
            membership_no: item.membership_no,
            vip_type: item.vip_type,
            start_date: item.start_date,
            end_date: item.end_date,
            amount: item.amount || 0,
            notes: item.notes || '',
            is_active: item.is_active,
            created_at: item.created_at ? formatDateTime(item.created_at) : '',
            updated_at: item.updated_at ? formatDateTime(item.updated_at) : ''
          }))
        })
        .catch(res => {
          this.$message.error(res?.message || '获取会员记录失败')
        })
    },
    openEdit(row) {
      this.current = {
        ...row,
        vip_type_id: row.vip_type?.id || row.vip_type_id || ''
      }
      this.dialogVisible = true
    },
    submit() {
      if (!this.current.vip_type_id) {
        this.$message.warning('请选择会员类型')
        return
      }
      const payload = {
        membership_no: this.current.membership_no,
        vip_type_id: this.current.vip_type_id,
        start_date: this.current.start_date || null,
        end_date: this.current.end_date || null,
        amount: this.current.amount || 0,
        notes: this.current.notes
      }
      this.request
        .post('/namzar/admin/memberships/edit', payload)
        .then(res => {
          if (res && (res.code === 200 || res.message)) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch(res => {
          this.$message.error(res?.message || '保存失败')
        })
    }
  }
}
</script>

<style scoped>
.memberships-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

.search-section {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
}

.custom-table {
  border-radius: 8px;
  overflow: hidden;
  min-width: 1000px;
}

.custom-table ::v-deep .el-table__header-wrapper {
  background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.search-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.headerBg {
  background: #eee !important;
}

.pagination-wrapper {
  margin-top: 16px;
  text-align: center;
}

.pagination-wrapper ::v-deep .el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
}

.edit-form ::v-deep .el-form-item {
  margin-bottom: 14px;
}

</style>


